module.exports = __webpack_public_path__ + "img/next.6fae31a4.svg";